var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
let ExEditorIconElement = class ExEditorIconElement extends LitElement {
    connectedCallback() {
        super.connectedCallback();
        this.renderIcon();
    }
    renderIcon() {
        var _a;
        const packedIcon = this.name ? (_a = this.editor) === null || _a === void 0 ? void 0 : _a.useIcon(this.name) : null;
        if (packedIcon) {
            this.icon = packedIcon;
        }
        else if (this.fallback) {
            this.fallback().then((icon) => {
                this.icon = icon;
                this.requestUpdate();
            });
        }
    }
    render() {
        return this.icon ? html `${unsafeSVG(this.icon)}` : nothing;
    }
};
// :host width&min-width 为了避免把浮动工具栏撑爆
ExEditorIconElement.styles = css `
    :host {
      display: inline-flex;
      vertical-align: middle;
      max-height: 100%;
      align-items: center;
      width: min-content;
      min-width: fit-content;
    }
    svg:not([fill]) {
      fill: currentColor;
    }
    svg:not([width]) {
      width: 100%;
      height: 100%;
    }
    svg[width] {
      max-width: 100%;
      max-height: 100%;
    }
  `;
__decorate([
    property({ reflect: true })
], ExEditorIconElement.prototype, "name", void 0);
__decorate([
    property()
], ExEditorIconElement.prototype, "editor", void 0);
__decorate([
    property()
], ExEditorIconElement.prototype, "fallback", void 0);
ExEditorIconElement = __decorate([
    customElement('exeditor-icon')
], ExEditorIconElement);
export { ExEditorIconElement };
export function createIcon(config) {
    return Object.assign(document.createElement('exeditor-icon'), config);
}
//# sourceMappingURL=icon.js.map